<template lang="pug">
.error-continter
  CommonHeader
  .error-block
    img.error-img(src="https://m.hellobike.com/resource/gallery/61/DU04Mzws24.png?x-oss-process=image/quality,q_80")
  .reload-btn(@click="refresh") 刷新再试
</template>
<script>
import CommonHeader from '@/components/common-middle-header';

export default {
  components: {
    CommonHeader,
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    },
  },
};
</script>
<style lang="less" scoped>
.error-continter {
  height: 100vh;
  background: #fff;

  .error-block {
    display: flex;
    justify-content: center;
    padding-top: 2rem;

    img.error-img {
      width: 1.6rem;
      height: 1.25rem;
    }
  }

  .reload-btn {
    font-size: 0.14rem;
    background: #08f;
    color: #fff;
    width: 1rem;
    height: 0.4rem;
    border-radius: 0.12rem;
    text-align: center;
    line-height: 0.4rem;
    margin: 0.2rem auto;
  }
}
</style>
